module.exports = __webpack_public_path__ + "img/empty-code.png?3a5f7fc9";